import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowUpGreen",
  "use": "ArrowUpGreen-usage",
  "viewBox": "0 0 182.13 181.53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 182.13 181.53\" id=\"ArrowUpGreen\"><path fill=\"#39b3ae\" d=\"M150.9 154.95V26.59H22.53v23.09h88.95l-97.11 97.1 16.33 16.33L127.81 66v88.95h23.09z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol